import { ECoinTypeAvailabilityMode, ICoinTypeAvailabilityMode } from './module/coins'
import { timeConstant } from './constants'

interface ISumSubConfig {
    API_URL: string // 'https://api.sumsub.com' or 'https://test-api.sumsub.com'
    ACCESS_TOKEN_LIFESPAN_IN_SECONDS: number
    FLOW_NAME: Record<string, string>
}

interface IRestrictedRegionDto {
    countryName: string
    prohibitedStates?: { isoCode: string; name: string }[]
}
type TRestrictedRegionMap = Record<string, IRestrictedRegionDto>

interface IAppServicesConfigState {
    IS_DEVELOPMENT: boolean
    BUILD_BRANCH_NAME: string
    VERCEL_ENVIRONMENT: string
    VERCEL_PREVIEW_URL: string

    DOMAIN: string
    NEXT_API_URL: string

    PARTNERSHIP_EMAIL: string
    SUPPORT_EMAIL: string
    SUPPORT_PHONE: string

    PRICE_FETCH_INTERVAL: number
    COIN_PRICES_INTERVAL: number
    ORDER_DETAILS_INTERVAL: number
    RECENT_ORDERS_SIZE: number
    RECENT_ORDERS_INTERVAL: number

    WARNING_TIMEOUT: number
    COIN_INPUT_DEBOUNCE: number
    DEFAULT_COIN_MIN_AMOUNT_MULTIPLIER: number
    DEFAULT_COIN_MIN_AMOUNT_CUSTOMS: number[] | null
    CUSTOM_EXCLUDED_COINS: string[] // example ['ZEC', 'XMR', 'DASH']
    CUSTOM_POPULAR_COINS: string[] // example ['BTC', 'ETH', 'XRP']
    EXCHANGE_WIDGET_CONFIG: Record<string, ICoinTypeAvailabilityMode>

    GOOGLE_TAG_MANAGER_CONTAINER_ID: string
    INTERCOM_APP_ID: string
    REFERRAL_CODE: string

    AUTH_EXPIRATION_PERIOD: number

    DEFAULT_PAYMENT_METHOD?: string

    SUM_SUB: ISumSubConfig
    TEST_ORDERS: {
        TEST_WALLET_ADDRESSES: string[]
        TEST_COIN_CODES: string[]
    }

    readonly RESTRICTED_REGION_MAP: TRestrictedRegionMap
    readonly SHORT_RESTRICTED_REGION_MAP: TRestrictedRegionMap
}

class AppConfigContext {
    private config = <IAppServicesConfigState>(<unknown>{
        PRICE_FETCH_INTERVAL: 60000,
        COIN_PRICES_INTERVAL: 60000,
        ORDER_DETAILS_INTERVAL: 10000,
        RECENT_ORDERS_SIZE: 5,
        RECENT_ORDERS_INTERVAL: 30000,

        WARNING_TIMEOUT: 5000,
        COIN_INPUT_DEBOUNCE: 500,
        DEFAULT_COIN_MIN_AMOUNT_MULTIPLIER: 2,
        DEFAULT_COIN_MIN_AMOUNT_CUSTOMS: null,
        CUSTOM_EXCLUDED_COINS: [],
        CUSTOM_POPULAR_COINS: [],
        EXCHANGE_WIDGET_CONFIGS: {
            INDEX: {
                FROM_AVAILABILITY_MODE: 'CRYPTO',
                TO_AVAILABILITY_MODE: 'CRYPTO',
            },
        },
        REFERRAL_CODE: null,

        AUTH_EXPIRATION_PERIOD: 8 * timeConstant.WEEK,

        TEST_ORDERS: {
            TEST_WALLET_ADDRESSES: [],
            TEST_COIN_CODES: [],
        },

        SUM_SUB: <ISumSubConfig>{},
        RESTRICTED_REGION_MAP: <TRestrictedRegionMap>{},
    })

    setAppConfig(config: IAppServicesConfigState) {
        return (this.config = { ...config })
    }

    getAppConfig(): IAppServicesConfigState {
        try {
            return { ...this.config }
        } catch (ex) {
            console.error('Error in App Config')
            return this.config as IAppServicesConfigState
        }
    }
}

const appConfigContext = new AppConfigContext()

export type { IAppServicesConfigState, TRestrictedRegionMap }
export { appConfigContext }
